import React from "react";
import { Trans } from "react-i18next";
import { Button, Stack } from "@mui/material";
import { isAndroid, isIos, redirectToStore } from "tools/device";

const NewAppVersionAvailable: React.FC = () => {
  return (
    <Stack direction="column" alignItems="center" justifyContent="center">
      <Trans parent="p">A new app version is available.</Trans>
      <Button variant="outlined" size="small" onClick={() => redirectToStore()}>
        {isIos() && <Trans>Update in the App Store</Trans>}
        {isAndroid() && <Trans>Update in Google Play</Trans>}
      </Button>
    </Stack>
  );
};

export default NewAppVersionAvailable;
